import { render, staticRenderFns } from "./DlvRL_Row.vue?vue&type=template&id=e5736f24"
import script from "./DlvRL_Row.vue?vue&type=script&lang=js"
export * from "./DlvRL_Row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports